


$(document).ready(function () {
  $(".product-block-group--checkin-store .checkin-store-button").click(function () {
  const $modal = $(".m-modal-store-stock");

  // Always make sure it's visible & animated
  $modal.css({
    "display": "block",     
    "opacity": "1"         
  });

  // Trigger reflow to restart animation if needed
  $modal.removeClass("active");
  void $modal[0].offsetWidth;

  $modal.addClass("active m-open-modal");
});

 
    $(".m-modal-store-stock .m-modal--close").click(function () {
        $(".m-modal-store-stock").removeClass("m-open-modal").css("opacity", "0");
        $(".m-modal-location").removeClass("m-open-modal").css("opacity", "0");
    });
    $(".m-modal-location .btn-find-store").click(function () {
        $(".m-modal-location").removeClass("m-open-modal").css("opacity", "0");
    });
    //======================= Out side click -- Closed popUP ===========================
    $('.m-modal-store-stock').click(function(e) {
        if (!$(e.target).closest('.m-modal-store-stock .m-modal--content').length){
            $(".m-modal-store-stock").removeClass("m-open-modal").css("opacity", "0");
            // $(".m-modal-location").removeClass("m-open-modal").css("opacity", "0");
        }
    });
    $('.m-modal-location').click(function(e) {
        if (!$(e.target).closest('.m-modal-location .m-modal--content').length){
            // $(".m-modal-store-stock").removeClass("m-open-modal").css("opacity", "0");
            $(".m-modal-location").removeClass("m-open-modal").css("opacity", "0");
        }
    });

    // ========================================== Do your code above side ===================================
});
$(".userlocation-button , .btn-my-location").on("click", function (event) {
    event.preventDefault();
    $(".m-modal-store-stock .size-with-store-details").hide();
    if ($(event.currentTarget).hasClass("btn-my-location")) {
        $(".m-modal-location").removeClass("m-open-modal").css("opacity", "0");
    }
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
            function (position) {
                // console.log("position", position)
                var lat = position.coords.latitude;
                var lng = position.coords.longitude;
                var selLatiInput = document.getElementById("sel-lati");
                var selLongiInput = document.getElementById("sel-longi");
                selLatiInput.value = lat;
                selLongiInput.value = lng;
                get_current_location(lat, lng);
            },
            function (error) {
                console.error("Error getting location: " + error.message);
            }
        );
    } else {
        alert("Geolocation is not supported by this browser.");
    }
});


//new get_current_location code
async function get_current_location(latitude, longitude) {
    const apiKey = "AIzaSyAb6l1y4zzD3MTrZ_GMWbMo_7-KOFY5hIc"; // Google API key
    const lat = latitude;
    const lng = longitude;
    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;
//component.types.includes("locality") ||
   console.log("lat", lat, "lng", lng)
    try {
        const response = await fetch(url);
        const data = await response.json();

        if (data.status === "OK") {
            const results = data.results[0];
            const addressComponents = results.address_components;

            let country = "",
                province = "",
                suburb = "";
// console.log("addressComponents", addressComponents)
            addressComponents.forEach((component) => {
                if (component.types.includes("country")) {
                    country = component.short_name;
                } else if (component.types.includes("administrative_area_level_1")) {
                    province = component.long_name;
                } else if (
                    component.types.includes("sublocality_level_2") ||
                    component.types.includes("sublocality_level_1") ||
                    component.types.includes("sublocality")
                ) {
                    suburb = component.long_name;
                }
            });
            console.log("country", country, "province", province, "suburb", suburb  )
            // country check
            if (
                country === "ZA" ||
                country === "NA" ||
                country === "LS" ||
                country === "SZ" ||
                country === "BW"
            ) {
                provinceData(country);
                if (province) {
                    suburbData(province);
                }
                $(`#country option[value="${country}"]`).prop("selected", true);
                setTimeout(function () {
                    $(`#suburb option[value="${suburb}"]`).prop("selected", true).length || $('#suburb').append(`<option value="${suburb}">${suburb}</option>`).find(`option[value="${suburb}"]`).prop("selected", true);
                    $(`#province option[value="${province}"]`).prop("selected", true).length || $('#province').append(`<option value="${province}">${province}</option>`).find(`option[value="${province}"]`).prop("selected", true);
                }, 1500);
                // Fetch and display the closest 10 stores with stock
                await fetch_closest_stores_with_stock(lat, lng);

            } else {
                const defaultLat = -24.599596; // Default latitude
                const defaultLng = 31.048521; // Default longitude
                await  get_current_location(defaultLat, defaultLng);
                console.error("Location is not in South Africa.");

            }
        } else {
            console.error("Geocoding API error:", data.status);
        }
    } catch (error) {
        console.error("Error fetching data:", error);
    }
}
async function fetch_closest_stores_with_stock(lat, lng) {
    try {
        $(".m-modal-store-stock").addClass("m-spinner-loading")
        const response = await $.ajax({
            url: `${get_all_store_data}`,
            type: "GET",
            dataType: "json",
            headers: {
                Authorization: "Bearer D31599216G16AD76EAF5E77CE4BD3EDF645B8A6B", // Replace with your API key
            },
        });

        const storesWithDistance = response.map(item => {
            const distance = calculateDistance(lat, lng, item.latitude, item.longitude);
            return { ...item, distance };
        }).sort((a, b) => a.distance - b.distance);

        const storesWithinRadius = storesWithDistance.filter(item => item.distance <= 50).slice(0, 20);

        const itemsWithStock = [];
        var liveSku = $("#pro-variants option:selected").attr("data-sku");
        for (const item of storesWithinRadius) {
            const storeResponse = await selected_store_Data(item.branchCode, liveSku);
            if (storeResponse && storeResponse.qty > 0) {
                const correctResponse = response.find(item => item.branchCode.includes(storeResponse.branch));
                itemsWithStock.push(correctResponse);
            }
        }
        if (itemsWithStock.length === 0) {
            let data = { responseText: "No stores found with stock within 50km radius" };
            showing_error_result(data, $("#store-stock"));
        } else {
            const flattenedItemsWithStock = itemsWithStock.flat();
            showing_result_store_stock(flattenedItemsWithStock);
        }
        $(".m-modal-store-stock").removeClass("m-spinner-loading");
        $(".m-spinner-button").addClass("hidden-after-spin");
    } catch (error) {
        console.error("Error fetching data", error);
    }
}

function calculateDistance(lat1, lng1, lat2, lng2) {
    const R = 6371; // Radius of the Earth in km
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLng = (lng2 - lng1) * Math.PI / 180;
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
        Math.sin(dLng / 2) * Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c; // Distance in km
}
//end new get_current_location code

$("#pro-variants").on("change", function () {
    var selsku = $("#pro-variants option:selected").attr("data-sku");
    const selValue = $("#suburb option:selected").val();
    const selProvince = $("#province option:selected").val();
    $(".m-modal-store-stock .error-message").text("")
    $(".product-details .sku-label").find(".inner-txt").text(selsku);
    $(".m-modal-store-stock .size-with-store-details").hide();
    if (selValue && selProvince) {
        store_stock_Data(selProvince, selValue);
    }
});
$("#country").on("change", function () {
    var selVal = $("#country option:selected").val();
    const sel_suburb = $("#suburb option:selected").val();
    const sel_store = $("#store-stock option:selected").val();
    const suburb_dropdown = $("#suburb");
    const store_dropdown = $("#store-stock");
    $(".m-modal-store-stock .error-message").text("")
    if (sel_suburb || sel_store) {
        suburb_dropdown.empty().append('<option value="" disabled selected hidden>Please Select</option>').attr('disabled', 'true');
        store_dropdown.empty().append('<option value="" disabled selected hidden>Please Select</option>').attr('disabled', 'true');
        $(".m-modal-store-stock .size-with-store-details").hide();
    }else{
        suburb_dropdown.empty().append('<option value="" disabled selected hidden>Please Select</option>').attr('disabled', 'true');
        $(".m-modal-store-stock .size-with-store-details").hide();
    }
    // console.log("selVal" , selVal)
    provinceData(selVal);
});
$("#province").on("change", function () {
    console.log("province change")
    var selVal = $("#province option:selected").val();
    const sel_suburb = $("#suburb option:selected").val();
    const sel_store = $("#store-stock option:selected").val();
    const suburb_dropdown = $("#suburb");
    const store_dropdown = $("#store-stock");
    $(".m-modal-store-stock .error-message").text("")
   // if (sel_suburb || sel_store) {
        suburb_dropdown.empty().append('<option value="" disabled selected hidden>Please Select</option>').attr('disabled', 'true');
        store_dropdown.empty().append('<option value="" disabled selected hidden>Please Select</option>').attr('disabled', 'true');
        $(".m-modal-store-stock .size-with-store-details").hide();
    //}
    suburbData(selVal);
    // console.log("selVal" , selVal)
});
$("#suburb").on("change", function () {
    var selVal = $("#suburb option:selected").val();
    const selProvince = $("#province option:selected").val();

    $(".m-modal-store-stock .error-message").text("")
    $(".m-modal-store-stock .size-with-store-details").hide();
    // console.log("selVal" , selVal)
    if (selVal && selProvince) {
        store_stock_Data(selProvince, selVal);
    }});
$("#store-stock").on("change", function () {
    var selVal = $("#store-stock").val();
    $(".m-modal-store-stock .error-message").text("")
    // console.log("selVal", selVal)
    showSuggestions(selVal)

});

async function provinceData(selected_country_code) {
    try {
        const response = await $.ajax({
            url: `${provinceDataUrl}/${selected_country_code}`,
            type: "GET",
            dataType: "json",
            headers: {
                Authorization: "Bearer D31599216G16AD76EAF5E77CE4BD3EDF645B8A6B",
            },
        });

        // =========== Success response =================
        showing_result_province(response);
        // Ensure this is not called again after setting the province
        console.log("Province data populated");

    } catch (error) {
        showing_error_result(error, $("#province"));
        console.error("Error fetching data", error);
    }
}

async function suburbData(selected_province) {
    try {
        const response = await $.ajax({
            url: `${suburbDataUrl}/${selected_province}`,
            type: "GET",
            dataType: "json",
            headers: {
                Authorization: "Bearer D31599216G16AD76EAF5E77CE4BD3EDF645B8A6B",
            },
        });
        // =========== Success response =================
        showing_result_suburb(response);
        console.log("selected: ", selected_province);
        $(`#suburb option[value="${suburb}"]`).prop("selected", true);

    } catch (error) {
        showing_error_result(error, $("#suburb"));
        console.error("Error fetching data", error);
    }
}

async function store_stock_Data(selected_province, selected_subur) {
    try {
        $(".m-modal-store-stock").addClass("m-spinner-loading");
        const response = await $.ajax({
            url: `${storestock_Url}/${selected_province}/${selected_subur}`,
            type: "GET",
            dataType: "json",
            headers: {
                Authorization: "Bearer D31599216G16AD76EAF5E77CE4BD3EDF645B8A6B",
            },
        });
        // =========== Success response =================
        // console.log("response", response);

        const itemsWithStock = [];
        var liveSku = $("#pro-variants option:selected").attr("data-sku");
        for (const item of response) {
            const storeResponse = await selected_store_Data(item.branchCode, liveSku);
            // console.log("storeResonse", storeResponse.qty);
            if (storeResponse && storeResponse.qty > 0) {
                const correctResponse = response.find(item => item.branchCode.includes(storeResponse.branch));
                // console.log("correctResponse",correctResponse);
                itemsWithStock.push(correctResponse);
            }
        }
        if (itemsWithStock.length === 0) {
            let data = { responseText: "No stores found with stock" };
            showing_error_result(data, $("#store-stock"));
            console.log("no stores found should trigger the error above ")
            //itemsWithStock.push(["no stores found with stock"]);
        }else{
            const flattenedItemsWithStock = itemsWithStock.flat();
            // console.log("result", flattenedItemsWithStock);
            showing_result_store_stock(flattenedItemsWithStock);
        }
        $(".m-modal-store-stock").removeClass("m-spinner-loading")
    } catch (error) {
        console.error("Error fetching data", error);
        // $(".m-modal-store-stock").removeClass("m-spinner-loading")
        // showing_error_result(error, $("#store-stock"));
    }
}

async function selected_store_Data(selected_store, selected_sku) {
    var live_sku =
        selected_sku || $("#pro-variants option:selected").attr("data-sku");
    if (live_sku) {
        try {
            const response = await $.ajax({
                url: `${selected_store_data_Url}/${live_sku}/location/${selected_store}`,
                type: "GET",
                dataType: "json",
                headers: {
                    Authorization: "Bearer D31599216G16AD76EAF5E77CE4BD3EDF645B8A6B",
                },
            });
            // =========== Success response =================
            //console.log("stores ", response);
            return response;
        } catch (error) {
            console.error("Error fetching data", error);
            //alert("No inventory found on selected store");
            return null;
        }
    } else {
        //alert("Please select the variant");
        return null;
    }
}

function showing_result_province(data) {
    const selectBox = $("#province");
    selectBox.removeAttr("disabled");
    selectBox.empty(); // Clear previous suggestions
    selectBox.append(
        '<option value="" disabled selected hidden>Please Select</option>'
    );
    console.log ("showing_result_province data: ", data);
    data.forEach((option) => {
        const list_of_option = `<option value="${option.province}">${option.province}</option>`;
        if (option.province) {
            selectBox.append(list_of_option);
        }
    });
}

function showing_error_result(data, element) {
  console.log("Store stock fetch failed:"+data);
  element.empty();
  let message = "Something went wrong. Please try again later.";
  if (data && data.responseText) {
    message = data.responseText;
  }
  element.append(`
    <option value="" disabled selected hidden>${message}</option>
  `);
  $(".size-with-store-details").css("display","block");
  $(".m-modal-store-stock .store-details").html(`
    <div class="no-store-msg" style="    padding: 20px;
    color: #000000;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    margin-top: 26%;">
     This item is not available in any stores near you
    </div>
  `);
}

function showing_result_suburb(data) {
    const selectBox = $("#suburb");
    selectBox.removeAttr("disabled");
    //selectBox.empty(); // Clear previous suggestions
    selectBox.append(
        '<option value="" disabled selected hidden>Please Select</option>'
    );
    data.forEach((option) => {
        const list_of_option = `<option value="${option.suburb}">${option.suburb}</option>`;
        if (option.suburb) {
            selectBox.append(list_of_option);
        }
    });
}

function showing_result_store_stock(data) {

    const selectBox = $("#store-stock");
     if (data.length > 0) {

        $(".store-option").on("click", function() {
            $(".store-option").removeClass("selected");
            $(this).addClass("selected");
            const storeId = $(this).data("store-id");
            showSuggestions(storeId);
        });

        displaySuggestions(data);
        showing_final_result($("#pro-variants option:selected").attr("data-sku"));
    } else {
        selectBox.html('<div class="no-stores">No stores found with stock</div>');
    }
}
function showing_final_result(data) {
    const selectBox = $(".m-modal-store-stock .size-with-store-details");
    const allvari = $(".product-selectable-attributes button");
    const selectvari = $(
        `.product-selectable-attributes button[data-sku-id='${data}']`
    );
    if (data) {
        allvari.addClass("unavail");
        selectvari.removeClass("unavail");
        selectBox.show();
        $(".m-modal-store-stock .error-message").text("")
    }
}

var storeData = []; // Initialize an empty array
async function fetchStoreData() {
    try {
        const response = await $.ajax({
            url: get_all_store_data,
            type: "GET",
            dataType: "json",
            headers: {
                Authorization: "Bearer D31599216G16AD76EAF5E77CE4BD3EDF645B8A6B",
            },
        });
        storeData = response;
    } catch (error) {
        console.error("Error fetching data", error);
    }
}
fetchStoreData();
async function showSuggestions(store_id) {
    const sku_id = $("#pro-variants option:selected").attr("data-sku");
    const input = store_id.toLowerCase();
    const suggestions = storeData.filter((store) => {
        return (store.branchCode ? store.branchCode.toLowerCase() : "").includes(input);
    });

    const lat = parseFloat($("#sel-lati").val());
    const lng = parseFloat($("#sel-longi").val());

    if (!isNaN(lat) && !isNaN(lng)) {
        suggestions.forEach(suggestion => {
            if (suggestion.distance === undefined && suggestion.latitude && suggestion.longitude) {
                suggestion.distance = calculateDistance(lat, lng, suggestion.latitude, suggestion.longitude);
            }
        });
    }

    displaySuggestions(suggestions);
    showing_final_result(sku_id);
}
async function displaySuggestions(suggestions) {
    console.log("displaySuggestions", suggestions);
    const suggestionBox = $(".m-modal-store-stock .store-details");
    suggestionBox.empty(); // Clear previous suggestions
     suggestionBox.append('<div style="color: #656565;" class="store-name">Please call the store to reserve your item.</div>');
    suggestions.forEach((suggestion, index) => {
        let distanceText = "Distance unavailable";
        
        if (suggestion.distance !== undefined) {
            distanceText = `${suggestion.distance.toFixed(1)} km away`;
        } else {
            // Get user coordinates
            const lat = parseFloat($("#sel-lati").val());
            const lng = parseFloat($("#sel-longi").val());
            
            // Try to calculate distance if both store and user coordinates exist
            if (!isNaN(lat) && !isNaN(lng) && 
                suggestion.latitude && suggestion.longitude) {
                const distance = calculateDistance(lat, lng, 
                    parseFloat(suggestion.latitude), 
                    parseFloat(suggestion.longitude));
                suggestion.distance = distance;
                distanceText = `${distance.toFixed(1)} km away`;
            }
        }
        
var schedule = JSON.parse(suggestion.openingHours);
var formattedHours = "";

// Format store hours
$.each(schedule, function (day, times) {
    var open = times.open ? times.open.slice(0, 5) : "Closed";
    var close = times.close ? times.close.slice(0, 5) : "Closed";
    var allDay = times.all_day ? "Open All Day" : `${open} - ${close}`;
    formattedHours += `<span class="span-block">${day.charAt(0).toUpperCase() + day.slice(1)}: ${allDay}</span>`;
});

        
        // Build each store block
        const storeHTML = `
          
            <div class="store-block " data-index="${index}">
              <br/>
                <!-- Collapsed view -->
                <div class="store-half-details" style="cursor: pointer;">
                  <div class="custom-name-distance">
                    <div class="store-name">${suggestion.store_name}</div>
                    <div class="distance-arrow">
                      <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                          <path d="M7.03222 12C6.89012 11.9345 6.81554 11.8138 6.74977 11.6778C6.06714 10.2642 5.38069 8.85269 4.69717 7.4394C4.66663 7.37626 4.62817 7.33602 4.56417 7.30518C3.13401 6.61322 1.70502 5.91862 0.275159 5.22578C0.155074 5.16763 0.0534863 5.09597 0.0132621 4.96145C-0.0387062 4.78699 0.059652 4.60696 0.257249 4.52648C0.555554 4.40489 0.855913 4.28859 1.1551 4.16876C4.57532 2.80041 7.99496 1.43176 11.4149 0.0631219C11.7141 -0.0567078 11.8468 -0.0132402 11.9998 0.25667V0.467547C11.9592 0.487225 11.9598 0.530399 11.9463 0.564468C10.4648 4.26685 8.98295 7.96953 7.50376 11.6728C7.44533 11.8188 7.37163 11.9404 7.21984 12H7.03252H7.03222ZM10.1362 1.3789C10.1295 1.36774 10.123 1.35628 10.1163 1.34512C7.16024 2.52815 4.2042 3.71117 1.23114 4.90095C2.41731 5.4766 3.58176 6.0408 4.74415 6.60882C4.82548 6.64847 4.86746 6.63554 4.92853 6.57416C6.63556 4.86248 8.34494 3.15314 10.0543 1.44381C10.0787 1.41943 10.1089 1.40034 10.1362 1.3786V1.3789ZM7.09975 10.7717C8.29004 7.79478 9.47239 4.8381 10.6547 1.88142C10.6139 1.88876 10.594 1.90668 10.5752 1.92577C8.85523 3.64656 7.13557 5.36764 5.41386 7.08696C5.3616 7.13924 5.35338 7.17448 5.38685 7.24262C5.76942 8.02474 6.14759 8.80892 6.52722 9.59252C6.71454 9.97873 6.90216 10.3649 7.09975 10.772V10.7717Z" fill="#00A655"/>
                        </svg>
                      </span>
                      <span>${distanceText}</span>
                    </div>
                  </div>
                  <p>${suggestion.address1}, ${suggestion.address2}, ${suggestion.province},${suggestion.postalCode}</p>
                  <div class="custom-name-distance">
                    <div class="detais-with-lable">In Stock</div>
                    <button class="view-dietail-button" style="text-decoration-line: underline;font-size: 14px;font-family: 'Roboto';font-weight: 400;">View Details</button>
                  </div>
                </div>
                <div id="storeModal" class="modal-overlay" style="display: none;">
                  <div class="modal-content">                  
                    <div id="modalStoreDetails">
                    </div>
                  </div>
                </div>

                <!-- Hidden expanded view -->
                <div class="store-full-details" style="display: none;">
                    <div class="model_upper_name">Check-in store availability</div>
                         <button class=" back-button" style="margin-top: 10px;"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="auto" x="0" y="0" viewBox="0 0 24 24" style="enable-background:new 0 0 512 512" xml:space="preserve"><g><path fill-rule="evenodd" d="M11.648 20.048a1.2 1.2 0 0 1-1.696 0l-7.2-7.2a1.2 1.2 0 0 1 0-1.696l7.2-7.2a1.2 1.2 0 0 1 1.696 1.696L6.497 10.8H20.4a1.2 1.2 0 1 1 0 2.4H6.497l5.151 5.152a1.2 1.2 0 0 1 0 1.696Z" clip-rule="evenodd" fill="#000000" opacity="1" data-original="#000000"></path></g></svg>Back</button>
                    <h4>${suggestion.store_name}</h4>
                    <div class="row">
                        <div class="col call-and-directions">
                             <a class="tell-link"  href="${suggestion.googleUrl}" target="_blank" 
                                <span class="phone-icon">
                                    <img src="https://cdn.shopify.com/s/files/1/0652/8634/0780/files/icon-left.png?v=1744806998" width="16">
                                </span> Get Directions
                            </a>
                            <a class="tell-link" href="tel:${suggestion.phone}">
                                <span class="phone-icon">
                                    <img src="https://cdn.shopify.com/s/files/1/0652/8634/0780/files/phone-call.png?v=1721887378" width="16">
                                </span> Call the store
                            </a>
                        </div>
                      <br />
                      <div class="store-detail store_hours">
                          <div class="title-custom"><strong>Trading hours</strong></div>
                          <div class="detail custom-time">${formattedHours}</div>
                      </div>
                      <br />
                      <div class="store-detail store_location">
                        <div class="title"><strong>Address</strong></div>
                        <div class="detail custom-time">
                        <span class="span-block">${suggestion.address1}</span>
                        <span class="span-block">${suggestion.address2}</span>
                        <span class="span-block">${suggestion.province}</span>
                        <span class="span-block">${suggestion.postalCode}</span>
                        </div>
                    </div>
                    </div>
           
                </div>
              <br/>
              <hr>
            </div>
        `;      
        suggestionBox.append(storeHTML);
    });

    bindStoreToggleEvents();
}

function bindStoreToggleEvents() {
  $('.m-modal-store-stock .store-details').off('click').on('click', function (e) {
    const target = $(e.target);
    const parent = target.closest('.store-block');

    if (target.hasClass('view-dietail-button')) {
      const fullDetails = parent.find('.store-full-details').html();
      $('#modalStoreDetails').html(fullDetails);
      $('#storeModal').fadeIn();
         
        $('#mainContent').hide();
    
    }
  });



  
  $(document).on('click', '.back-button', function () {
    $('#storeModal').fadeOut();
    $('#mainContent').show();
      // $('.m-modal-store-stock .m-modal--content').css('overflow', '');
  });

  $(document).on('click', '#storeModal', function (e) {
    if ($(e.target).is('#storeModal')) {
      $('#storeModal').fadeOut();
      $('#mainContent').show();
    }
  });
}
  document.addEventListener('DOMContentLoaded', function () {
    // ===== Modal Show =====
    document.querySelectorAll('.store-details .view-dietail-button').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        const parent = btn.closest('.store-block');
        const fullDetails = parent.querySelector('.store-full-details').innerHTML;

        // Inject dynamic HTML into modal content
        document.getElementById('modalStoreDetails').innerHTML = fullDetails;

        // Show modal
        const modal = document.querySelector('.m-modal-store-stock');
        modal.classList.add('active');
        modal.style.display = 'block';

        // Optional: hide background content
        document.getElementById('mainContent').style.display = 'none';
      });
    });

    // ===== Modal Close (background click or close button) =====
    const modalWrapper = document.querySelector('.m-modal-store-stock');
    const closeBtn = document.querySelector('.m-modal--close');

    // Close on clicking background
    modalWrapper.addEventListener('click', function (e) {
      if (e.target === modalWrapper || e.target === closeBtn) {
        closeSlideModal();
      }
    });

    // Prevent closing modal when clicking inside modal content
    const modalContent = document.querySelector('.m-modal--content');
    modalContent.addEventListener('click', function (e) {
      e.stopPropagation();
    });

    // Close function
    function closeSlideModal() {
      modalWrapper.classList.remove('active');
      setTimeout(() => {
        modalWrapper.style.display = 'none';
        document.getElementById('mainContent').style.display = 'block';
      }, 300); // matches CSS transition
    }
  });




  // function showLoader() {
  //   document.querySelector('.loader1').style.display = 'block';
  // }

  // function hideLoader() {
  //   document.querySelector('.loader1').style.display = 'none';
  // }

function showLoader() {
  const loader = document.querySelector('.loader1');
  if (loader) loader.style.display = 'block';
}

function hideLoader() {
  const loader = document.querySelector('.loader1');
  if (loader) loader.style.display = 'none';
}


  document.addEventListener('DOMContentLoaded', async function () {
    hideLoader(); // page load par loader hide karo

    // Google Autocomplete search
    const auOptions = {
      componentRestrictions: { country: "za" }
    };

    const { Autocomplete } = await google.maps.importLibrary("places");
    const autocomplete = new Autocomplete(document.getElementById("address-input"), auOptions);
    autocomplete.addListener('place_changed', async function () {
      showLoader(); // loader start

      document.querySelector(".m-modal-store-stock .size-with-store-details").style.display = 'none';
      const place = autocomplete.getPlace();
      if (!place || !place.geometry) {
        console.error("No geometry returned from place selection");
        hideLoader();
        return;
      }

      const sel_lati = parseFloat(place.geometry.location.lat());
      const sel_longi = parseFloat(place.geometry.location.lng());
      if (!Number.isFinite(sel_lati) || !Number.isFinite(sel_longi)) {
        console.error("Invalid coordinates from place selection", sel_lati, sel_longi);
        hideLoader();
        return;
      }

      document.getElementById("sel-lati").value = sel_lati;
      document.getElementById("sel-longi").value = sel_longi;

      await fetch_closest_stores_with_stock(sel_lati, sel_longi);

      hideLoader(); // loader stop
    });

    // Use My Location button
    document.querySelector('.btn-my-location').addEventListener('click', function () {
      showLoader(); // loader start

      navigator.geolocation.getCurrentPosition(async function (position) {
        const lat = parseFloat(position.coords.latitude);
        const lng = parseFloat(position.coords.longitude);
        if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
          console.error("Invalid geolocation coordinates", lat, lng);
          hideLoader();
          return;
        }

        document.getElementById("sel-lati").value = lat;
        document.getElementById("sel-longi").value = lng;

        await fetch_closest_stores_with_stock(lat, lng);

        hideLoader(); // loader stop
      }, function (error) {
        console.error("Location access denied:", error);
        hideLoader(); // hide loader if location access fails
      });
    });
  });






